
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { Job } from '@/domains/global/models'
import TranslationActivityView from '@/domains/jobs/components/TranslationActivityView.vue'

import JobActionButtons from './JobActionButtons.vue'
import JobTabs from './JobTabs.vue'
import JobDetailsTab from './JobDetailsTab.vue'
import JobDisputeMessage from './JobDisputeMessage.vue'
import BrokerJobDetails from '@/domains/jobs/components/Read/BrokerJobDetails.vue'

@Component({
  components: { BrokerJobDetails, JobActionButtons, JobDetailsTab, JobTabs, JobDisputeMessage, TranslationActivityView }
})
export default class JobReadPage extends Vue {
  @Prop({ type: Object as () => Job, required: true })
  readonly job!: Job

  tab = null

  get isBroker () {
    return this.job.brokerId === this.$store.state.auth.agencyId
  }

  refreshData() {
    this.$emit('refresh')
  }

  unassignJob(job: Job) {
    this.$emit('unassign', job)
  }

  saveJob(job: Job) {
    this.$emit('update:job', job)
  }

  abandonJob(data: { job: Job, reason: string }) {
    this.$emit('abandon', data)
  }
}
